var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserStarLineUser = function SvgUserStarLineUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.667v1.667a5 5 0 0 0-5 5H3.335a6.666 6.666 0 0 1 6.667-6.667Zm0-.833c-2.762 0-5-2.238-5-5 0-2.763 2.238-5 5-5 2.763 0 5 2.237 5 5 0 2.762-2.237 5-5 5Zm0-1.667A3.332 3.332 0 1 0 10 2.5a3.332 3.332 0 1 0 0 6.667Zm5 8.75-2.448 1.287.467-2.726-1.98-1.932 2.738-.398L15 11.667l1.225 2.48 2.737.399-1.98 1.932.466 2.726-2.448-1.287Z",
    fill: "#999FB4"
  })));
};
export default SvgUserStarLineUser;